// styles
import s from './ProductModalBackground.sss';

// types
type ProductModalBackgroundProps = {
  productImg: string,
  productName: string,
};

export const ProductModalBackground: React.FC<ProductModalBackgroundProps> = (
  {
    productImg,
    productName,
  },
) => (
  <div className={s.image} style={{ backgroundImage: `url(${productImg})` }}>
    <h2 className={s.title}>
      {productName}
    </h2>
  </div>
);

export default ProductModalBackground;
